import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {environment} from '../../../../src/environments/environment';
import {ObjectModel} from './object.model';
import {BehaviorSubject, EMPTY, isObservable, Observable, Subject} from 'rxjs';
import {ReactiveAction, ReactiveEvent, ReactiveService} from '../reactive-service.abstract';
import {catchError, shareReplay} from 'rxjs/operators';
import {ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {CalcparamModel} from '../calcparam/calcparam.model';
import {ObjectShortModel} from './object.short.model';


@Injectable()
export class ObjectsShortestApiService extends ReactiveService {

  private baseUrl = environment.backEndUrlPrefix + '/' + 'db/object';


  constructor(private http: HttpClient) {
    super();
  }

  getAll() {
    return this.http.get<ObjectShortModel[]>(this.baseUrl + '/shortest');
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<CalcparamModel[]> | Promise<CalcparamModel[]> | CalcparamModel[] {
    return this.getAll();
  }

}
